import React, { useState, useEffect } from "react";
import {
  DatePicker,
  Radio,
  Button,
  Modal,
  Form,
  Select,
  InputNumber,
  message,
} from "antd";
import ReportApi from "@api/report";
import Title from "@/components/Title";
import Analysisapi from "@/api/analysis";
import moment from "moment";
import Area from "@/components/twoarea";
import Ocharts from "./ochart.js";
import "./../style.scss";
import "./style.css";
import { wait } from "@testing-library/react";
const { RangePicker } = DatePicker;
export default ({ history }) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

  const stationIds = userInfo.stationIds ? userInfo.stationIds.split(",") : [];
  const date = new Date();
  const Year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  var clock = Year + "-";
  var clock1 = Year + "-";
  if (month < 10) {
    clock += "0";
    clock1 += "0";
  }
  clock += month + "-";
  clock1 += month + "-";
  if (day < 10) {
    clock += "0";
    clock1 += "0";
  }
  clock += day + " ";
  clock1 += day + 1 + " ";
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [station, setStation] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [stationId, setStationId] = useState();
  const [defaultDate, setDefaultDate] = useState();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    queryTimeStartStr: clock + "00:00:00",
    queryTimeEndStr: clock1 + "00:00:00",
    reportType: 1,
    type: '',
    inOrOut: 4,
    stationId: stationId,
    dutyUserStationIds: stationIds,
  });

  useEffect(() => {
    if (stationId&&searchParams.type) {
      findOutWaterQuality();
    }
  }, [searchParams]);

  useEffect(() => {
	  
	  getStation();
    
  }, []);

  const getStation = () => {
    Analysisapi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        setStation(res.data);
        const id = res.data[0] ? res.data[0].id : -1;
        setStationId(id);
        setSearchParams({ ...searchParams, stationId: id });
		getSelectYaoTypeList();
      }
    });
  };
  const getStationId = (id, tag) => {
    if (tag == 1) {
      setSearchParams({
        ...searchParams,
        stationId: id,
      });
      setStationId(id);
    }
  };
  const findOutWaterQuality = () => {
    let data = { ...searchParams, stationId: stationId };
    if (data.reportType == 1) {
      data.queryTimeEndStr =
        moment(new Date()).format("YYYY-MM-DD ") + "23:59:59";
    }
    ReportApi.selectYaoSurface(data).then((res) => {
      if (res.status == 0 && res.data) {
		  let data = res.data.map(item=>{
			  return {
				...item,
				createTime: item.createTime.split('.')[0],
				value: Number(Number(item.value).toFixed(2))
			}
		  })
        setData(data);
      }
    });
  };
  const getSelectYaoTypeList = () => {
    Analysisapi.selectYaoTypeList().then((res) => {
      if (res.status == 0 && res.data) {
        setTypeList(res.data);
		if(res.data.length)
			setSearchParams({ ...searchParams, type: res.data[0].id });
			
      }
    });
  };
  const changeType = (e) => {
	  setSearchParams({
	    ...searchParams,
	    type: e,
	  });
  }
  //时间查询
  const DateQuery = (obj, tag) => {
    if (tag == 1) {
      setDefaultDate(obj);
      const startTime = moment(obj[0]).format("YYYY-MM-DD") + " 00:00:00";
      const endTime = moment(obj[1]).format("YYYY-MM-DD") + " 00:00:00";
      setSearchParams({
        ...searchParams,
        queryTimeStartStr: startTime,
        queryTimeEndStr: endTime,
      });
    }
  };
  //年月日查询
  const slotQuery = (obj, tag) => {
    let firstDate = "";
    let endDate = "";
    if (month < 10) {
      firstDate = Year + "-" + "0" + month + "-01";
    } else {
      firstDate = Year + "-" + month + "-01";
    }
    let currentMonth = date.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    let lastTime = new Date(nextMonthFirstDay - oneDay);
    let cmonth = parseInt(lastTime.getMonth() + 1);
    let cday = lastTime.getDate();
    if (cmonth < 10) {
      cmonth = "0" + cmonth;
    }
    if (cday < 10) {
      cday = "0" + cday;
    }
    endDate = date.getFullYear() + "-" + cmonth + "-" + cday;
    const bstartTime = moment(firstDate).format("YYYY-MM-DD") + " 00:00:00";
    const bendTime = moment(endDate).format("YYYY-MM-DD") + " 23:59:59";

    let firstDay = new Date();
    firstDay.setDate(1);
    firstDay.setMonth(0);
    let lastDay = new Date();
    lastDay.setFullYear(lastDay.getFullYear() + 1);
    lastDay.setDate(31);
    lastDay.setMonth(-1);
    firstDay = moment(firstDay).format("YYYY-MM-DD") + " 00:00:00";
    lastDay = moment(lastDay).format("YYYY-MM-DD") + " 23:59:59";

    if (tag == 1) {
      setDefaultDate(null);
      if (obj.target.value == "day") {
        setSearchParams({
          ...searchParams,
          queryTimeStartStr: clock + "00:00:00",
          queryTimeEndStr: clock1 + "00:00:00",
          reportType: 1,
        });
      }
      if (obj.target.value == "month") {
        setSearchParams({
          ...searchParams,
          reportType: 2,
          queryTimeStartStr: bstartTime,
          queryTimeEndStr: bendTime,
        });
      }
      if (obj.target.value == "year") {
        setSearchParams({
          ...searchParams,
          reportType: 3,
          queryTimeStartStr: firstDay,
          queryTimeEndStr: lastDay,
        });
      }
    }
  };

  const submit = () => {
    form.validateFields().then((values) => {
      const params = {
        ...values,
        dayTime: values.dayTime.format("YYYY-MM-DD HH:mm:ss"),
        dutyUserStationIds: stationIds,
      };
      setConfirmLoading(true);
      Analysisapi.yaoDoseUpdate(params)
        .then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("设置成功");
          cancle();
          findOutWaterQuality();
        })
        .catch(() => {
          setConfirmLoading(false);
        });
    });
  };

  const cancle = () => {
    form.resetFields();
    setVisible(false);
  };

  return (
    <div className="baseContent quality">
      <div className="column" style={{ position: "relative" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Title title="药剂量分析"></Title>
          {/*<Button type="primary" onClick={() => setVisible(true)}>
            手动添加
          </Button>*/}
        </div>

        <div className="area">
          <span
            style={{
              position: "absolute",
              marginLeft: "18px",
              borderBottom: "1px solid #EEF0F3",
              padding: "11px 15px 12px 5px",
              zIndex: "999",
            }}
          >
            厂站:
          </span>
          <Area station={station} getStationId={(e) => getStationId(e, 1)} />
          <div className="solid"></div>
          <div className="tdate">
            时间：
            <RangePicker
              value={defaultDate}
              allowClear={false}
              onChange={(e) => {
                DateQuery(e, 1);
              }}
              style={{ width: "220px" }}
            />
          </div>
        </div>
		<div>
			<span style={{marginLeft: "30px"}}>药耗类型：</span>
			<Select style={{width: '180px'}} value={searchParams.type} onChange={(e)=>changeType(e)} placeholder="请选择药耗类型">
			  {typeList.map((item) => (
			    <Select.Option value={item.id} key={item.id}>
			      {item.name}
			    </Select.Option>
			  ))}
			</Select>
		</div>
        <Radio.Group
          onChange={(e) => {
            slotQuery(e, 1);
          }}
          className="button"
          style={{ position: "absolute", width: "200px" }}
        >
          <Radio.Button className="button-children" value="day">
            日
          </Radio.Button>
          <Radio.Button className="button-children" value="month">
            月
          </Radio.Button>
          <Radio.Button className="button-children" value="year">
            年
          </Radio.Button>
        </Radio.Group>
        <Ocharts data={data} />
      </div>
      <Modal
        open={visible}
        title="手动添加药剂量"
        onCancel={cancle}
        onOk={submit}
        confirmLoading={confirmLoading}
      >
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} form={form}>
          <Form.Item
            label="日期"
            name="dayTime"
            rules={[{ required: true, message: "请选择日期" }]}
          >
            <DatePicker showTime placeholder="请选择日期" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="报表类型"
            name="reportType"
            rules={[{ required: true, message: "请选择报表类型" }]}
          >
            <Radio.Group>
              <Radio value={1}>日</Radio>
              <Radio value={2}>月</Radio>
              <Radio value={3}>年</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="所属厂站"
            name="stationId"
            rules={[{ required: true, message: "请选择所属厂站" }]}
          >
            <Select placeholder="请选择所属厂站">
              {station.map((item) => (
                <Select.Option value={item.id} key={item.id}>
                  {item.aliasName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="用药量"
            name="value"
            rules={[{ required: true, message: "请填写药量" }]}
          >
            <InputNumber placeholder="请填写药量" style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
